//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform';
import Multiselect from 'vue-multiselect';
import swal from 'sweetalert2';

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            options: [
                { name: 'Western Europe, North America or Australasia' },
                { name: 'Eastern Europe'},
                { name: 'Africa'},
                { name: 'Asia and Middle East'},
                { name: 'Latin America or Caribbean '}
            ],
            form: new Form({
                is_organisation: true,
                organisation_name: '',
                first_name: '',
                last_name: '',
                email: '',
                headquarter_location: '',
                regions: {
                    western_europe_north_america: false,
                    eastern_europe: false,
                    africa: false,
                    asia_middle_east: false,
                    latin_america: false,
                },
                hear_about: '',
                want_to_sing_up: '',
                twitter: '',
                website: '',
                terms: false,
                name: '',
                location: '',
                subscribe_together_first: false,
                subscribe_una_uk: false
            }),
            showModal: false
        };
    },

    methods: {
        save() {
            this.form.post('/api/join-us')
                .then(({ data }) => {
                    if (data && data.success) {
                        this.form.reset();
                        swal.fire({
                            title: 'Thank you!',
                            text: 'Thanks for making a difference and signing up to our mission',
                            type: 'success',
                            confirmButtonText: 'Close'
                        });
                    }
                });
        }
    }
};
